// extracted by mini-css-extract-plugin
export default {"PRIMARY_COLOR":"#516beb","SECONDARY_COLOR":"#fcc312","SURFACE_COLOR":"#f0f3f8","BACKGROUND_COLOR":"#eee"};